<div *ngIf="listType === phoneNumberList.nameValueListTypes.ABSENCE_WHITELIST">
  <p>{{'whitelist.description_incoming' | translate}}</p>
</div>
<div *ngIf="listType === phoneNumberList.nameValueListTypes.WHITELIST_OUTGOING">
  <p>{{'whitelist.description_outgoing' | translate}}</p>
</div>
<div *ngIf="listType === phoneNumberList.nameValueListTypes.COMPANY_WHITELIST_OUTGOING">
  <p>{{'whitelist.description_outgoing' | translate}}</p>
</div>

<gt-phone-number-list [listType]="listType" [orgName]="orgId" [canEdit]="canEdit" [login]="login">
</gt-phone-number-list>


<div *ngIf="phoneNumberList?.phonenumberEntries?.length === 0 && !canEdit">
  {{'whitelist.none' | translate}}
</div>
